import { getNavigationUrl } from '../../../utils';
import { Widget } from '../../../apiService';
import Carousel from '../../../Carousel';
import ContentList from '../../../ContentList';

const CarouselWidget = ({ widget }: { widget: Widget<'regular_carousel' | 'promoted_carousel'> }) => {
  const {
    configuration: { items, navigation_configuration },
    display_title,
    id,
  } = widget;
  const more = getNavigationUrl(navigation_configuration,undefined, undefined, id);

  return (
    <Carousel m={0} title={display_title} more={more}>
      <ContentList items={items.map(({ video_content }) => video_content)} />
    </Carousel>
  );
};

export default CarouselWidget;
